import constants from '../constants';

const initialState = {
  selectedStore: null,
  storeLocations: [],
  isLoading: false,
};

export default function selectedStoreReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_SELECTED_STORE:
      return {
        ...state,
        selectedStore: action.payload,
      };
    case constants.CLEAR_SELECTED_STORE:
      return {
        ...state,
        selectedStore: null,
      };
    case constants.SET_STORE_LOCATIONS:
      return {
        ...state,
        storeLocations: action.payload,
      };
    case constants.SET_STORE_LOCATIONS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
